import angular from 'angular';
import uiRouter from 'angular-ui-router';
import procedureComponent from './procedure.component';

let procedureModule = angular.module('procedure', [
    uiRouter
])

.config(($stateProvider) => {
    'ngInject';
    $stateProvider
        .state('editProcedure', {
            url: '/procedures/:id',
            component: 'procedure',
            parent: 'main',
            data: {
                permissions: {
                    only: ['OPERATOR'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                procedure: (ProceduresService, $stateParams) => {
                    return ProceduresService.findById($stateParams.id, {
                        include: ['client', {
                            relation: 'collectionItems',
                            scope: {
                                include: [{
                                    relation: 'collection',
                                    scope: {
                                        include: 'employee'
                                    }
                                }, 'receipt', 'checks', 'bankTxes',
                                          'paymentItems' ]
                            }
                        }]
                    });
                }
            }
        });
})
.component('procedure', procedureComponent)
.name;

export default procedureModule;
